/** Safe Chart.js placeholders before SWR data arrives. */
export const emptyRetailerStackedBarChart = {
  chart: { labels: [], datasets: [] },
  retailerChartHasAnyData: false,
};

export const emptyPromotionalFrequencyLineChart = {
  chart: { labels: [], datasets: [] },
  frequencyLineHasAnyData: false,
};

export const emptyProvinceOfferCountChart = {
  chart: { labels: [], datasets: [] },
  provinceChartHasAnyData: false,
};
